import { h, Host, } from "@stencil/core";
import state from "../store";
import { exportParts } from "../../common/export-parts";
export class GxgTabButton {
    constructor() {
        this.hidden = false;
        this.tabLabel = null;
        this.tab = null;
        this.isSelected = false;
        this.disabled = false;
        this.icon = null;
    }
    parts = {
        button: "button",
    };
    exportparts;
    el;
    tabButton;
    //Events
    tabActivated;
    PrevOrNextTab;
    async tabButtonClick() {
        this.buttonClickHandler();
        this.tabButton.focus();
    }
    isSelectedHandler(newValue) {
        if (newValue) {
            this.el.removeAttribute("tabindex");
        }
        else {
            this.el.setAttribute("tabindex", "-1");
        }
    }
    hiddenHandler(hidden) {
        if (hidden) {
            this.el.setAttribute("tabindex", "-1");
        }
        else {
            this.el.removeAttribute("tabindex");
        }
    }
    buttonClickHandler() {
        this.isSelected = true;
        const index = parseInt(this.el.getAttribute("data-index"), 10);
        this.tabActivated.emit({
            tab: this.tab,
            index: index,
        });
    }
    buttonKeyDownHandler(e) {
        if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
            this.PrevOrNextTab.emit({
                originTab: this.tab,
                arrowPressed: e.key,
            });
        }
        else if (e.key === "ArrowUp" || e.key === "ArrowDown") {
            e.preventDefault();
        }
    }
    printIcon() {
        if (this.icon !== null) {
            if (this.disabled) {
                return (h("gxg-icon", { color: "disabled", type: this.icon, part: "icon" }));
            }
            return h("gxg-icon", { type: this.icon, part: "icon" });
        }
    }
    componentWillLoad() {
        this.attachExportParts();
        this.hiddenHandler(this.hidden);
    }
    attachExportParts = () => {
        const part = this.el.getAttribute("part");
        const exportPartsResult = exportParts(part, this.parts);
        exportPartsResult.length && (this.exportparts = exportPartsResult);
    };
    componentDidLoad() {
        //Set the active tab for this tab-button if this is selected by default
        if (this.isSelected) {
            this.tabActivated.emit();
        }
    }
    render() {
        return (h(Host, { class: {
                large: state.large,
                mercury: state.mercury,
            }, exportParts: this.exportparts ? this.exportparts : null }, h("li", { class: "tab-item" }, h("button", { disabled: this.disabled, class: {
                "tab-button": true,
                "tab-button--hidden": this.hidden,
                "tab-button--selected": this.isSelected === true,
                "tab-button--text-icon": this.tabLabel !== null && this.icon !== null,
                large: state.large,
            }, onClick: this.buttonClickHandler.bind(this), onKeyDown: this.buttonKeyDownHandler.bind(this), ref: (el) => (this.tabButton = el), part: this.parts.button }, this.printIcon(), h("span", { class: "tab-button__text", part: "button-text" }, this.tabLabel)), h("slot", null))));
    }
    static get is() { return "gxg-tab-button"; }
    static get encapsulation() { return "shadow"; }
    static get delegatesFocus() { return true; }
    static get originalStyleUrls() {
        return {
            "$": ["tab-button.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["tab-button.css"]
        };
    }
    static get properties() {
        return {
            "hidden": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Hides the tab button"
                },
                "attribute": "hidden",
                "reflect": false,
                "defaultValue": "false"
            },
            "tabLabel": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The button label"
                },
                "attribute": "tab-label",
                "reflect": false,
                "defaultValue": "null"
            },
            "tab": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The tab id. Must be unique, and match the \"tab\" value of the correlative \"gxg-tab\" element"
                },
                "attribute": "tab",
                "reflect": true,
                "defaultValue": "null"
            },
            "isSelected": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Provide this attribute to make this button selected by default"
                },
                "attribute": "is-selected",
                "reflect": false,
                "defaultValue": "false"
            },
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Provide this attribute to make this button disabled"
                },
                "attribute": "disabled",
                "reflect": false,
                "defaultValue": "false"
            },
            "icon": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "(Optional) provide an icon to this button"
                },
                "attribute": "icon",
                "reflect": false,
                "defaultValue": "null"
            }
        };
    }
    static get events() {
        return [{
                "method": "tabActivated",
                "name": "tabActivated",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }, {
                "method": "PrevOrNextTab",
                "name": "PrevOrNextTab",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }];
    }
    static get methods() {
        return {
            "tabButtonClick": {
                "complexType": {
                    "signature": "() => Promise<void>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<void>"
                },
                "docs": {
                    "text": "",
                    "tags": []
                }
            }
        };
    }
    static get elementRef() { return "el"; }
    static get watchers() {
        return [{
                "propName": "isSelected",
                "methodName": "isSelectedHandler"
            }, {
                "propName": "hidden",
                "methodName": "hiddenHandler"
            }];
    }
}
//# sourceMappingURL=tab-button.js.map
